module.exports = __webpack_public_path__ + "img/nav-design-vintage.83c2940.jpg";